module.exports = __webpack_public_path__ + "img/box2_img1.ba96196e.png";